/*
 * TagName
 *
 * Every tag in a project is actually just an index to a TagName so we can rename a Tag quickly
 */
import { mergeRight, pick, tagged } from '@range.io/functional'
import TagNameSelectors from 'range-editor/src/redux/persisted-state/tag-name-slice/tag-name-selectors.js'
import { v4 } from 'uuid'
import StringTypes from '../string-types.js'

// ---------------------------------------------------------------------------------------------------------------------
// Definitions
// ---------------------------------------------------------------------------------------------------------------------

// prettier-ignore
const TagName = tagged('TagName', {
    id  : StringTypes.Id,
    name: 'String',
    isHidden: 'Boolean?' // default is false: not hidden
})

// ---------------------------------------------------------------------------------------------------------------------
// Serialization
// ---------------------------------------------------------------------------------------------------------------------

/*
 * @sig fromFirebase = {k:v} -> TagName
 */
TagName.fromFirebase = TagName.from
TagName.toFirebase = tagName => pick(['id', 'name', 'isHidden'], tagName)

/*
 * Create a new TagName merging an old one with values from changes
 * @sig update :: (TagName, {k:v}) -> TagName
 */
TagName.update = (upload, changes) => TagName.from(mergeRight(upload, changes))

TagName.fromName = name =>
    TagName.from({
        id: v4(),
        name,
        isHidden: false,
    })

/*
 * Extend our prototype with more functions -- but only if we're using Redux. We don't really want this file to know
 * about Redux per se, but it's nice to have these additional functions defined here if we ARE using Redux, so there's
 * only one place to look for them.
 *
 * @see store.js for calls to extendForRedux
 */
// prettier-ignore
TagName.extendForRedux = (getState, defineGetter) => {
    defineGetter(TagName, 'count',        _this => TagNameSelectors.computeTagCountData(getState())[_this.id].count)
    defineGetter(TagName, 'canvasCounts', _this => TagNameSelectors.computeTagCountData(getState())[_this.id].canvasCounts)
}

export default TagName
